import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ROLES } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import InvoiceList from './pages/InvoiceList';
import InvoiceBuilder from './pages/InvoiceBuilder';
import InvoiceView from './pages/InvoiceView';
import ClientList from './pages/ClientList';
import ClientForm from './pages/ClientForm';
import Settings from './pages/Settings';
import ClientPortal from './pages/ClientPortal';
import UserManagement from './pages/UserManagement';
import Reports from './pages/Reports';
import LandingPage from './pages/LandingPage';
import TechStackPopup from './components/TechStackPopup';
import StripeReturn from './pages/StripeReturn';
import StripeRefresh from './pages/StripeRefresh';
import PaymentSuccess from './pages/PaymentSuccess';
import './App.css';

const OWNER = [ROLES.BUSINESS_OWNER];
const OWNER_ACCOUNTANT = [ROLES.BUSINESS_OWNER, ROLES.ACCOUNTANT];
const CLIENT_ONLY = [ROLES.CLIENT];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Business Owner + Accountant */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={OWNER_ACCOUNTANT}>
                <Layout><Dashboard /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoices"
            element={
              <ProtectedRoute allowedRoles={OWNER_ACCOUNTANT}>
                <Layout><InvoiceList /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoices/:id"
            element={
              <ProtectedRoute allowedRoles={OWNER_ACCOUNTANT}>
                <Layout><InvoiceView /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute allowedRoles={OWNER_ACCOUNTANT}>
                <Layout><Reports /></Layout>
              </ProtectedRoute>
            }
          />

          {/* Business Owner only */}
          <Route
            path="/invoices/new"
            element={
              <ProtectedRoute allowedRoles={OWNER}>
                <Layout><InvoiceBuilder /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoices/edit/:id"
            element={
              <ProtectedRoute allowedRoles={OWNER}>
                <Layout><InvoiceBuilder /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <ProtectedRoute allowedRoles={OWNER}>
                <Layout><ClientList /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients/new"
            element={
              <ProtectedRoute allowedRoles={OWNER}>
                <Layout><ClientForm /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients/edit/:id"
            element={
              <ProtectedRoute allowedRoles={OWNER}>
                <Layout><ClientForm /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute allowedRoles={OWNER}>
                <Layout><UserManagement /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute allowedRoles={OWNER}>
                <Layout><Settings /></Layout>
              </ProtectedRoute>
            }
          />

          {/* Client only */}
          <Route
            path="/client-portal"
            element={
              <ProtectedRoute allowedRoles={CLIENT_ONLY}>
                <Layout><ClientPortal /></Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/invoice/:id/success"
            element={<PaymentSuccess />}
          />

          {/* Stripe Connect flow */}
          <Route
            path="/stripe/return"
            element={
              <ProtectedRoute allowedRoles={OWNER}>
                <StripeReturn />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stripe/refresh"
            element={
              <ProtectedRoute allowedRoles={OWNER}>
                <StripeRefresh />
              </ProtectedRoute>
            }
          />

          {/* Root: Landing Page; fallback redirects to root */}
          <Route path="/" element={<LandingPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <TechStackPopup />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;